import baseUrl from './baseUrl';
import isTokenExpired from '../helpers/isTokenExpired';

const URL_GET_ALL_CHAMADOS = `${baseUrl}/chamado/admin`;

const getAllChamados = async (pageNumber = 1, limit = 50, filterBy = 'createdAt', orderBy = 'desc') => {
  try {
    const token = window.localStorage.getItem('token');

    if (token) {
      if (isTokenExpired(token)) {
        window.localStorage.clear();
        window.location.replace('/');

        return;
      }
    }

    const data = await fetch(
      `${URL_GET_ALL_CHAMADOS}?page=${pageNumber}&limit=${limit}&filterBy=${filterBy}&orderBy=${orderBy}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }
      
    const response = await data.json();

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getAllChamados;
